'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _currentUserActions = require('../../user/currentUserActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        sendUserNavigate: function sendUserNavigate(_ref) {
            var currentUser = _ref.currentUser,
                newBoardId = _ref.newBoardId,
                previousBoardId = _ref.previousBoardId;

            if (currentUser.get('isGuest')) return;

            return dispatch((0, _currentUserActions.userNavigate)({ userId: currentUser.get('_id'), newBoardId: newBoardId, previousBoardId: previousBoardId }));
        }
    };
};

/**
 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
 * this version of React Router when the current route matches exactly ('/').
 */

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var WorkspaceNavigationDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(WorkspaceNavigationDecorator, _React$Component);

        function WorkspaceNavigationDecorator() {
            _classCallCheck(this, WorkspaceNavigationDecorator);

            return _possibleConstructorReturn(this, (WorkspaceNavigationDecorator.__proto__ || Object.getPrototypeOf(WorkspaceNavigationDecorator)).apply(this, arguments));
        }

        _createClass(WorkspaceNavigationDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _props = this.props,
                    currentUser = _props.currentUser,
                    currentBoardId = _props.currentBoardId,
                    sendUserNavigate = _props.sendUserNavigate,
                    socketConnected = _props.socketConnected;


                if (!currentBoardId || !socketConnected) return;
                sendUserNavigate({ currentUser: currentUser, newBoardId: currentBoardId });
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var currentUser = nextProps.currentUser,
                    currentBoardId = nextProps.currentBoardId,
                    sendUserNavigate = nextProps.sendUserNavigate,
                    socketConnected = nextProps.socketConnected;


                if (!currentBoardId || !socketConnected) return;

                if (this.props.currentBoardId !== currentBoardId) {
                    sendUserNavigate({
                        currentUser: currentUser,
                        newBoardId: currentBoardId,
                        previousBoardId: this.props.currentBoardId
                    });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return WorkspaceNavigationDecorator;
    }(_react2.default.Component)) || _class);


    WorkspaceNavigationDecorator.propTypes = {
        currentBoardId: _propTypes2.default.string,
        currentUser: _propTypes2.default.object,
        socketConnected: _propTypes2.default.bool,
        sendUserNavigate: _propTypes2.default.func
    };

    return WorkspaceNavigationDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/workspaceNavigationDecorator.js
// module id = 2156
// module chunks = 0